import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Link } from '@techstyle/next-routes';
import { Button } from '@techstyle/react-components';

const ButtonLink = styled(Button)`
  ${({ theme }) => theme.button.defaultStyle};
`;

function AssetCTA({ className, defaultText, options, onClick }) {
  const {
    customVars: { ctaUrl, ctaText, ctaTheme = '' },
  } = options;

  if (!ctaUrl) {
    return null;
  }

  return (
    <Link route={ctaUrl} passHref>
      <ButtonLink
        className={className}
        alternate={ctaTheme.includes('alternate')}
        secondary={ctaTheme.includes('secondary')}
        white={ctaTheme.includes('white')}
        onClick={onClick}
        tagName="a"
      >
        {ctaText || defaultText}
      </ButtonLink>
    </Link>
  );
}

AssetCTA.propTypes = {
  className: PropTypes.string,
  defaultText: PropTypes.node,
  options: PropTypes.shape({
    customVars: PropTypes.shape({
      ctaUrl: PropTypes.string,
      ctaText: PropTypes.string,
      ctaTheme: PropTypes.string,
    }),
  }).isRequired,
  onClick: PropTypes.func,
};

export default AssetCTA;
